import React from 'react';
import { UtilityBar } from '../components/UtilityBar';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TrustStrip } from '../components/TrustStrip';
import { BrandPartners } from '../components/BrandPartners';
import { ServicePathways } from '../components/ServicePathways';
import { WhyChoose } from '../components/WhyChoose';
import { Reviews } from '../components/Reviews';
import { ProjectGallery } from '../components/ProjectGallery';
import { ServiceArea } from '../components/ServiceArea';
import { HowItWorks } from '../components/HowItWorks';
import { ResidentialCommercial } from '../components/ResidentialCommercial';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { FloatingMobileCTA } from '../components/FloatingMobileCTA';
import { ChatWidget } from '../components/ChatWidget';
export function HomePage() {
  return <div className="min-h-screen bg-white font-body text-slate selection:bg-orange selection:text-white" data-id="element-618">
      <UtilityBar data-id="element-619" />
      <Header data-id="element-620" />
      <main data-id="element-621">
        <Hero data-id="element-622" />
        <TrustStrip data-id="element-623" />
        <BrandPartners data-id="element-624" />
        <ServicePathways data-id="element-625" />
        <WhyChoose data-id="element-626" />
        <Reviews data-id="element-627" />
        <ProjectGallery data-id="element-628" />
        <ServiceArea data-id="element-629" />
        <HowItWorks data-id="element-630" />
        <ResidentialCommercial data-id="element-631" />
        <FAQ data-id="element-632" />
        <FinalCTA data-id="element-633" />
      </main>
      <Footer data-id="element-634" />
      <FloatingMobileCTA data-id="element-635" />
      <ChatWidget data-id="element-636" />
    </div>;
}